import { AlertTriangle, Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface SystemSizeLimitModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentTier: string;
  systemSizeLimit: number;
  currentSize: number;
}

export function SystemSizeLimitModal({ isOpen, onClose, currentTier, systemSizeLimit, currentSize }: SystemSizeLimitModalProps) {
  const navigate = useNavigate();
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4">
        <div className="text-center mb-6">
          <div className="bg-yellow-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertTriangle className="h-8 w-8 text-yellow-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            System Size Limit Exceeded
          </h3>
          <p className="text-gray-600">
            Your {currentTier} plan has a {systemSizeLimit}kW system size limit. Your current design is {currentSize.toFixed(1)}kW.
          </p>
        </div>

        <div className="bg-blue-50 rounded-lg p-4 mb-6">
          <div className="flex">
            <Zap className="h-5 w-5 text-blue-500 flex-shrink-0" />
            <div className="ml-3">
              <h4 className="text-sm font-medium text-blue-800">
                Business Plan Benefits
              </h4>
              <ul className="mt-2 text-sm text-blue-700 list-disc list-inside">
                <li>Up to 50kW system size</li>
                <li>5 projects allowed</li>
                <li>Advanced design tools</li>
                <li>Priority support</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex space-x-4">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
          >
            Modify Design
          </button>
          <button
            onClick={() => navigate('/subscription')}
            className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
          >
            Upgrade Now
          </button>
        </div>
      </div>
    </div>
  );
}